import { XStack, YStack } from "tamagui";

import Doctor from "@/assets/images/doctor.png";
import {
  Button,
  Card,
  Heading,
  Image,
  Logo,
  Paragraph,
  Text,
} from "@/components";

type ChatOrVideoNoteProps = {
  description: string;
  onVideoPress: () => void;
  /** Omitted when live chat is closed, leaving video as the only modality offered. */
  onChatPress?: () => void;
};

export default function ChatOrVideoNote({
  description,
  onVideoPress,
  onChatPress,
}: ChatOrVideoNoteProps) {
  return (
    <Card
      display="flex"
      flexDirection="row"
      borderRadius="$200"
      overflow="hidden"
      $maxLg={{ flexDirection: "column" }}
    >
      <XStack
        width="50%"
        minWidth={0}
        backgroundColor="$fillClinician"
        $maxLg={{ minHeight: "$2000", width: "100%" }}
      >
        <YStack
          flex={1}
          gap="$150"
          paddingHorizontal="$300"
          paddingVertical="$200"
          paddingRight="$1400"
          zIndex={1}
        >
          <Text
            backgroundColor="$backgroundGround"
            paddingHorizontal="$150"
            paddingVertical="$75"
            borderRadius="$1000"
            size="$xs"
            bold
            alignSelf="flex-start"
          >
            LIMITED TIME OFFER
          </Text>

          <YStack gap="$50">
            <Heading size="$lg" maxWidth="$2400">
              FREE visit
            </Heading>
            <Text size="$sm" bold>
              ($39 value)
            </Text>
          </YStack>

          <XStack width="$2000" overflow="hidden" marginTop="auto">
            <Logo.MedicalGroup height="$150" />
          </XStack>
        </YStack>

        <Image
          source={Doctor}
          position="absolute"
          top={0}
          bottom={0}
          right={0}
          width="$2000"
          $lg={{ right: "$300" }}
          objectFit="cover"
          objectPosition="top center"
          pointerEvents="none"
          zIndex={0}
        />
      </XStack>

      <YStack
        width="50%"
        gap="$150"
        padding="$200"
        justifyContent="center"
        backgroundColor="$fillCallout"
        $maxLg={{ width: "100%" }}
      >
        <Paragraph>{description}</Paragraph>
        <Button
          mode="primary"
          onPress={() => onVideoPress()}
          dataTrackingId="select-video-visit-preference"
        >
          Video call with a clinician
        </Button>
        {onChatPress && (
          <Button
            mode="secondary"
            onPress={() => onChatPress()}
            dataTrackingId="select-chat-preference"
          >
            Chat with a clinician
          </Button>
        )}
        <Paragraph italic size="$2xs" lineHeight="$xs">
          To ensure a positive experience for everyone, we ask that all
          interactions with our care team remain respectful, as threatening or
          harassing behavior may result in your visit being cancelled.
        </Paragraph>
      </YStack>
    </Card>
  );
}
